export default __webpack_public_path__ + "static/media/hunger.ab345c5a.jpg";